import { render, staticRenderFns } from "./FavoriteAds.vue?vue&type=template&id=3ccfe513&lang=html&"
import script from "./FavoriteAds.vue?vue&type=script&lang=js&"
export * from "./FavoriteAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports